/**
 * Removes all but the largest width photos.
 * Example (result with two sources):
 * {photos: [{sources: [{size: {width: 500}}, {size: {width:815}}]}]}
 * returns
 * {photos: [{sources: [{size: {width: 815}}]}]}
 */
export function removeLowerResolutionPhotos({ photos, ...result }) {
  const highResolutionPhotos =
    photos &&
    photos.map(({ sources, ...photo }) => {
      let highestWidthPhotoSources = [];
      if (sources.length > 0) {
        highestWidthPhotoSources = [sources.reduce((max, next) => (max.size.width > next.size.width ? max : next))];
      }
      return { ...photo, sources: highestWidthPhotoSources };
    });
  return { ...result, photos: highResolutionPhotos };
}
